export default __webpack_public_path__ + "static/media/3536 spice rack F top.1b180bc3.png";